import { copyToClipboard } from '@/utils/copyToClipboard';
import { isTelegramApp } from '@/utils/isTelegramApp';

import { openTelegramLink as telegramOpenLink } from '@telegram-apps/sdk-react';

export function openTelegramLink(url: string, openInWeb = false) {
  try {
    if (isTelegramApp()) {
      telegramOpenLink(url);
    } else {
      if (openInWeb) window.open(url, '_blank');
      else copyToClipboard(url, 'Copied');
    }
  } catch (error) {
    console.error('Error when opening the link:', error);
    window.open(url, '_blank');
  }
}
